// extracted by mini-css-extract-plugin
module.exports = {"textDanger":"Shopee_textDanger__hl_EI","textBold":"Shopee_textBold__3cn0I","textSuccess":"Shopee_textSuccess__1fMxb"};